import React, { useState, useEffect } from "react";
import { PatientConfig } from "../../../../axiosConfig";
import { FAQ_STATIC_CONTENT } from "../../../../data/faqContent";

// Styles //
import styled from "styled-components";

// colors
import { THEME_COLORS } from "../../../../ThemeConfig";

// Components //
import BottomNavigation from "../../../general/BottomNavigation";

// Media-Images //
import arrowimg from "../../../../assets/images/expand_more.svg";
import arrowimg2 from "../../../../assets/images/expand_less.svg";

function Faq() {
    const [OptionsBox, setOptionsBox] = useState([]);

    useEffect(() => {
        PatientConfig.get("api/v1/general/faq/")
            .then((response) => {
                const data = response.data?.data;
                setOptionsBox(Array.isArray(data) && data.length > 0 ? data : FAQ_STATIC_CONTENT);
            })
            .catch(() => {
                setOptionsBox(FAQ_STATIC_CONTENT);
            });
    }, []);

    // show description for option
    const [isdown, setIsdown] = useState("");

    // Render each FAQ item
    const renderBox = OptionsBox.map((box) => {
        return (
            <ItemDiv key={box.id} className={isdown === box.id ? "active" : ""}>
                <ItemContent>
                    <LeftContainer>
                        <Label>{box.title}</Label>
                    </LeftContainer>
                    <RightContainer onClick={() => toggleDropdown(box.id)}>
                        <ArrowImage
                            src={isdown === box.id ? arrowimg2 : arrowimg}
                            alt="Arrow"
                        />
                    </RightContainer>
                </ItemContent>
                {isdown === box.id && <Para>{box.description}</Para>}
            </ItemDiv>
        );
    });

    const toggleDropdown = (boxId) => {
        setIsdown(isdown === boxId ? "" : boxId);
    };

    return (
        <>
            <MainContainer>
                <Wrapper>
                    <PageTitle>Frequently Asked Questions</PageTitle>
                    <Terms>
                        <ContentDiv>{renderBox}</ContentDiv>
                    </Terms>
                </Wrapper>
            </MainContainer>
            <BottomNavigation />
        </>
    );
}

export default Faq;

const MainContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${THEME_COLORS.page_bg_neutral};
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    padding: 24px 0 32px;
    @media all and (max-width: 768px) {
        padding-bottom: 80px;
    }
`;
const Wrapper = styled.div`
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    @media all and (max-width: 980px) {
        max-width: 90%;
    }
`;
const PageTitle = styled.h1`
    font-family: "DM_sans_medium";
    font-size: 26px;
    color: ${THEME_COLORS.secondary};
    text-align: center;
    margin: 0 0 28px;
    letter-spacing: -0.02em;
    @media all and (max-width: 480px) {
        font-size: 22px;
    }
`;
const Terms = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
const ContentDiv = styled.div`
    width: 100%;
`;
const Para = styled.p`
    margin: 0 0 0 4px;
    padding: 12px 0 16px;
    font-size: 15px;
    line-height: 1.6;
    font-family: "DM_sans";
    color: ${THEME_COLORS.text_para};
    border-top: 1px solid ${THEME_COLORS.light_300};
    @media all and (max-width: 360px) {
        font-size: 14px;
    }
`;
const ItemDiv = styled.div`
    width: 100%;
    padding: 18px 20px;
    margin-bottom: 12px;
    border-radius: 12px;
    background: ${THEME_COLORS.card_bg};
    border: 1px solid ${THEME_COLORS.light_300};
    box-shadow: ${THEME_COLORS.elevation_user_u4};
    transition: box-shadow 0.2s, border-color 0.2s;
    &.active {
        border-color: ${THEME_COLORS.primary};
        box-shadow: ${THEME_COLORS.elevation_user_u3};
    }
    @media all and (max-width: 360px) {
        padding: 14px 16px;
        margin-bottom: 8px;
    }
`;
const ItemContent = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
`;
const LeftContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 96%;
    margin-bottom: 0;
`;
const Label = styled.label`
    display: inline-block;
    font-family: "DM_sans_medium";
    font-size: 15px;
    line-height: 1.4;
    color: ${THEME_COLORS.text_title};
    width: 98%;
    cursor: pointer;
    @media all and (max-width: 360px) {
        font-size: 14px;
    }
`;
const RightContainer = styled.span`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
`;
const ArrowImage = styled.img`
    width: 100%;
    display: block;
`;
